<template>
  <nav class="bg-black-900 border-b border-gold-800 sticky top-0 z-50">
    <div class="container mx-auto px-6 py-4">
      <div class="flex items-center justify-between">
        <!-- Logo -->
        <router-link to="/" class="flex items-center space-x-3 !outline-none !ring-0">
          <div class="w-16 h-16 rounded-full flex items-center justify-center">
            <img src="@/assets/logo.png" alt="Canada Smile Logo" class="w-16 h-16">
          </div>
          <div>
            <h1 class="text-2xl font-display font-bold text-gold-400 mb-2">Canada Smile Lab</h1>
          </div>
        </router-link>

        <!-- Desktop Menu -->
        <div class="hidden md:flex items-center space-x-8">
          <router-link
              v-for="item in navItems"
              :key="item.name"
              :to="item.path"
              class="hover:text-gold-400 transition-colors duration-300 font-medium !outline-none !ring-0"
              active-class="text-gold-400"
          >
            {{ item.name }}
          </router-link>
        </div>

        <!-- Mobile menu button -->
        <button @click="toggleMenu" class="md:hidden text-gold-400 focus:outline-none focus:ring-2 focus:ring-gold-400 rounded-md p-1 !outline-none !ring-0">
          <svg class="w-8 h-8 transition-transform duration-300" :class="{'rotate-90': isMenuOpen}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path v-if="!isMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            <path v-if="isMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Mobile Menu -->
      <transition
        name="mobile-menu"
        @enter="startTransition"
        @after-enter="endTransition"
        @before-leave="startTransition"
        @after-leave="endTransition"
      >
        <div v-if="isMenuOpen" class="md:hidden overflow-hidden">
          <div class="flex flex-col space-y-4 pt-4 pb-4 !outline-none !ring-0">
            <transition-group
              name="mobile-menu-item"
              tag="div"
              class="flex flex-col space-y-4"
            >
              <router-link
                  v-for="item in navItems"
                  :key="item.name"
                  :to="item.path"
                  class="text-white hover:text-gold-400 transition-all duration-300 font-medium py-2 px-4 rounded-lg hover:bg-black-800 transform !outline-none !ring-0"
                  active-class="text-gold-400 bg-black-800"
                  @click="closeMenu"
              >
                {{ item.name }}
              </router-link>
            </transition-group>
          </div>
        </div>
      </transition>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      isMenuOpen: false,
      isTransitioning: false,
      navItems: [
        { name: 'Home', path: '/' },
        { name: 'Products', path: '/services' },
        { name: 'Gallery', path: '/gallery'},
        { name: 'About Us', path: '/about' },
        { name: 'RX Form', path: '/RXform'},
        { name: 'Contact', path: '/contact' }
      ]
    }
  },
  methods: {
    toggleMenu() {
      if (!this.isTransitioning) {
        this.isMenuOpen = !this.isMenuOpen
      }
    },
    closeMenu() {
      if (!this.isTransitioning) {
        this.isMenuOpen = false
      }
    },
    startTransition() {
      this.isTransitioning = true
    },
    endTransition() {
      this.isTransitioning = false
    }
  }
}
</script>

<style scoped>
/* Mobile menu transition */
.mobile-menu-enter-active,
.mobile-menu-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 300px;
}

.mobile-menu-enter-from,
.mobile-menu-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-10px);
}

.mobile-menu-enter-to,
.mobile-menu-leave-from {
  max-height: 300px;
  opacity: 1;
  transform: translateY(0);
}

/* Mobile menu items transition */
.mobile-menu-item-enter-active {
  transition: all 0.3s ease-out;
  transition-delay: calc(0.1s * var(--item-index));
}

.mobile-menu-item-leave-active {
  transition: all 0.2s ease-in;
  position: absolute;
}

.mobile-menu-item-enter-from,
.mobile-menu-item-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

.mobile-menu-item-enter-to,
.mobile-menu-item-leave-from {
  opacity: 1;
  transform: translateX(0);
}

/* Staggered animation for menu items */
.mobile-menu-item-move {
  transition: transform 0.4s ease;
}

/* Apply index-based delays for staggered animation */
.mobile-menu-item-enter-active:nth-child(1) { --item-index: 1; }
.mobile-menu-item-enter-active:nth-child(2) { --item-index: 2; }
.mobile-menu-item-enter-active:nth-child(3) { --item-index: 3; }
.mobile-menu-item-enter-active:nth-child(4) { --item-index: 4; }
</style>